// extracted by mini-css-extract-plugin
export default {"title":"_1B3cnMXTMoJPw0MKa9OVdk","box":"_2woGkXqZQHGoWv5kfjHeKS"};